// ============================================================
// GCC Industry & Origin-Company Taxonomy — shared data module
// Source: GCC_Industry_Domain_Taxonomy.md
// Used by both CHART Rubric (V1.2) and CHART Rubric Pro Intake
// forms, so the two products never drift out of sync on this.
// ============================================================
// v1.2.1: merged into ONE flat list, no longer filtered by Role
// Type — Role Type (a person's function) and Industry (the
// company's business) are independent, e.g. an HR professional
// (Non-IT role) can work at a TMT company. The old cascading
// filter incorrectly hid TMT from Non-IT-role candidates and
// Chartered Accountants/Actuaries from IT-role candidates.
//
// BFSI is split into 4 more specific display labels (Banking,
// Financial Services, Insurance, NBFC/Fintech) per Hardy's
// request — all 4 map to the SAME underlying 'BFSI' value, so
// the report's industry-aware content (keyed by BFSI) applies
// identically regardless of which of the 4 labels someone picks.
// This is a display-only split — zero new report content needed.
// ============================================================

export const INDUSTRY_OPTIONS = [
  { value: 'BFSI', label: 'Banking' },
  { value: 'BFSI', label: 'Financial Services' },
  { value: 'BFSI', label: 'Insurance' },
  { value: 'BFSI', label: 'NBFC/Fintech' },
  { value: 'Life_Sciences_Healthcare', label: 'Life Sciences & Healthcare' },
  { value: 'TMT', label: 'TMT (Technology, Media & Telecom)' },
  { value: 'ER_D', label: 'ER&D (Engineering, Manufacturing & Automotive)' },
  { value: 'Retail_Consumer_ProfServices', label: 'Retail, Consumer Goods & Professional Services' },
  { value: 'Chartered_Accountants_Actuaries', label: 'Chartered Accountants / Actuaries' },
  { value: 'Aerospace_Defence_Space', label: 'Aerospace, Defence & Space' },
  { value: 'Semiconductors_DeepTech', label: 'Semiconductors & Deep Tech' },
  { value: 'Energy_Materials_CleanTech', label: 'Energy, Materials & CleanTech' },
  { value: 'Other', label: 'Other' }
];

// Company Type — shown as a second, clearly labeled group within
// the same Industry dropdown (not a separate field as of v1.2.1).
// Same list regardless of Role Type. "Other" in either group also
// covers candidates not currently employed (between roles/laid
// off) — confirmed no dedicated option needed for that case.
export const ORIGIN_COMPANY_TYPES = [
  { value: 'Indian_IT_Services', label: 'Indian IT Services', hint: 'e.g. TCS, Infosys, Wipro, HCL Technologies, Tech Mahindra' },
  { value: 'Product_Tech_Mature', label: 'Product/Tech Companies (mature)', hint: 'e.g. Google, Microsoft, Amazon, Adobe, SAP' },
  { value: 'Global_IT_Services', label: 'Global IT Services', hint: 'e.g. Accenture, Capgemini, IBM, Cognizant, DXC Technology' },
  { value: 'Enterprise_MNC_Inhouse', label: 'Enterprise/MNC In-house Teams', hint: 'e.g. Siemens India, Bosch India, Schneider Electric India, Honeywell India, Philips India' },
  { value: 'BPO_KPO', label: 'BPO/KPO', hint: 'e.g. Genpact, WNS, Concentrix, [24]7.ai, EXL Service' },
  { value: 'Big_Four_Consulting_IT', label: 'Big Four/Consulting-IT', hint: 'e.g. Deloitte, PwC, EY, KPMG (technology/consulting arms)' },
  { value: 'Startups_Scaleups', label: 'Startups/Scale-ups', hint: 'e.g. early-to-growth-stage tech companies, including AI-native startups' },
  { value: 'Freelance_Gig_FixedTerm', label: 'Freelance / Gig / Independent / Fixed-Term Contract', hint: 'e.g. project-based freelancers, platform gig work, fixed-term contract executives' }
];
